import React from 'react';
import { Button, Label, Remark, ActionButton } from 'fw/components';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import API from 'fw/system/API';
import * as FormManager from 'fw/forms/form/FormManager'
import * as Notifications from 'fw/globals/Notifications';
import { Form, EmailBox, TextBox } from 'fw/forms';
import * as APIModules from 'modules/app/API';
import * as App from 'modules/app/App';
import * as Modals from 'fw/globals/Modals';

class AssociatedUserInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState(props) {
        return {
            originalEmail: '',
            disableFields: false,
            disableSave: false,
            disableContent: false,
            certificationKey: props.certificationKey,
            userId: props.userId,
            form: { userName: '' }
        };
    }

    handleCancel = () => {
        FormManager.checkUnsavedChanges(() => {
            if (this.props.onCancel)
                this.props.onCancel();
        })
    }

    componentDidMount() {
        this.loadUser(this.state.userId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userId !== this.props.userId)
            this.loadUser(nextProps.userId);
    }

    loadUser = (userId) => {

        if (userId === 0) {
            this.setState({
                userId: userId,
                disableContent: false,
                disableFields: false,
                disableSave: false,
                form: { userName: 'New User' }
            });
            return;
        }

        var rq = {
            userId: userId
        };

        new API().get(APIModules.Biz.url('/vobSetup/getAssociatedUserInfo'), rq,
            {
                success: (r) => {
                    // Store search results
                    this.setState({
                        disableContent: !r.data.registrationPending,
                        disableFields: !r.data.registrationPending,
                        disableSave: !r.data.registrationPending,
                        form: r.data
                    });
                }
            });

    }

    handleSubmit = () => {
        if (this.state.isValidated && !this._form.validate())
            return false;

        // Proceed
        var url = APIModules.Biz.url('/vobSetup/saveAssociatedUserInfo');

        let rq = {
            certificationKey: this.props.certificationKey,
            userId: this.state.form.userId,
            oldUserId: this.state.form.oldUserId,
            firstName: this.state.form.firstName,
            lastName: this.state.form.lastName,
            email: this.state.form.email,
            rowVersion: this.state.form.rowVersion
        };

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    Notifications.success(r.message);

                    this.setState({
                        dirty: false,
                        form: {
                            ...this.state.form,
                            ...r.data,
                            original: {
                                ...this.state.form,
                                ...r.data
                            }
                        }
                    }, this.props.onUpdate());
                    FormManager.reset();
                },
                error: r => {
                    Notifications.error(r.error.errorMessage);
                }
            })
        });
    }

    emailFocus = () => {
        this.setState({
            originalEmail: this.state.form.email,
            disableSave: true
        });
    }

    emailChange = () => {
        this.setState({ disableSave: false }, () => {

            if (this.state.originalEmail !== this.state.form.email) {
                var rq = {
                    certificationKey: this.props.certificationKey,
                    userId: this.state.form.userId,
                    email: this.state.form.email
                };

                new API().post(APIModules.Biz.url('/vobSetup/validateUserEmail'), rq, {
                    success: (r) => {
                        if (r.data != null) {
                            this.setState({
                                disableFields: false,
                                disableSave: false,
                                disableContent: true,
                                form: {
                                    ...this.state.form,
                                    ...r.data
                                }
                            });
                        }
                        else {
                            this.setState({
                                disableFields: false,
                                disableSave: false,
                                disableContent: false,
                            });
                        }
                    },
                    error: r => {
                        Notifications.error(r.error.errorMessage);
                        this.setState({
                            disableFields: false,
                            disableSave: false,
                            disableContent: false,
                        });
                    }
                });
            }
        });

        return false;
    }


    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    handleDelete = () => {
        const me = this;

        var rq = {
            certificationKey: this.props.certificationKey,
            userId: this.state.form.userId,
        };

        Modals.confirm(
            "Removing this User's Association will remove this Company from the User's 'Manage Company' tab. <br /><br />" +
            "If you wish to remove this User's Association, please select 'Yes'. <br /><br />" +
            "If you wish to Discard this change, please select 'No', and you will be returned to the previous screen.",
            function () {
                new API().post(APIModules.Biz.url('/vobSetup/removeUserAssociation'), rq,
                    {
                        success: (r) => {
                            Notifications.success(r.message);
                            FormManager.reset();
                            me.props.onUpdate()
                        },
                        error: (r) => {
                            Notifications.error(r.error.errorMessage);
                        }
                    });
            });
    }

    handleResendRegistration = () => {
        var rq = {
            userId: this.state.form.userId
        };

        Modals.confirm("This will resend the registration email for this user. Are you sure?", function () {
            new API().post(APIModules.Security.url('/registration/resendRegistration'), rq, {
                success: (r) => {
                    Notifications.success(r.message);
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
        });
    }

    renderActions() {
        if (this.state.userId === 0)
            return null;

        return (
            <div className="pull-right">
                {(App.hasPrivilege("ManageVobEdit") && this.state.form.registrationPending) &&
                    <ActionButton id="btnResendRegistration" onClick={this.handleResendRegistration} icon="envelope">Resend Registration</ActionButton>
                }
                {App.hasPrivilege("ManageVobEdit") && this.state.userId !== 0 &&
                    <ActionButton id="btRemoveAssociation" onClick={this.handleDelete} icon="trash">Remove User Association</ActionButton>
                }
            </div>
        )
    }

    render() {
        return (
            <React.Fragment>
                <ContentHeader title={this.state.form.userName}>
                </ContentHeader>
                <ContentBody>
                    <Row>
                        <Col md={12}>
                            <hr style={{ height: "1px", background: "#333" }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <Form
                                onChange={this.handleChange}
                                values={this.state.form}
                                unsavedChangesWarning={true}
                                ref={(form) => { this._form = form }}>
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label required>Email</Label>
                                            <EmailBox
                                                name="email"
                                                placeholder="Email"
                                                maxLength={255}
                                                required
                                                onBlur={this.emailChange}
                                                onFocus={this.emailFocus}
                                                ref={(c) => { this.focusControl = c; }}
                                                disabled={this.state.disableFields} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>First Name</Label>
                                            <TextBox
                                                name="firstName"
                                                placeholder="First Name"
                                                maxLength={30}
                                                required
                                                disabled={this.state.disableContent} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>Last Name</Label>
                                            <TextBox
                                                name="lastName"
                                                placeholder="Last Name"
                                                maxLength={30}
                                                disabled={this.state.disableContent}
                                                required />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {!this.state.adding && this.state.form.registrationPending &&
                                    <Row>
                                        <FormGroup bsClass="col-md-10">
                                            <Remark message="(*) This user has not completed registration yet." />
                                        </FormGroup>
                                    </Row>
                                }
                            </Form>
                        </Col>
                        <Col md={2}>
                            {this.renderActions && this.renderActions()}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="pull-right">
                                <Button id="btnCancel" bsStyle="link" onClick={() => this.handleCancel()}>Cancel</Button>
                                <Button id="btnSave" onClick={this.handleSubmit} bsStyle="primary" disabled={this.state.disableSave}>Save</Button>
                            </div>
                        </Col>
                    </Row>
                </ContentBody>
            </React.Fragment>
        )
    }
}

export default AssociatedUserInfo;


// WEBPACK FOOTER //
// ./src/areas/companyManagement/manageCompany/associatedUsers/AssociatedUserInfo.js